import api from '../api';
import { AlertThreshold } from '../../types';

export const alertThresholdService = {
  /** Fetch all active alert threshold definitions from the backend. */
  getThresholds: async (): Promise<AlertThreshold[]> => {
    const { data } = await api.get<AlertThreshold[]>('/alert-thresholds');
    return data;
  },
};
